module.exports = __webpack_public_path__ + "static/media/renewableenargyloan.458db075.svg";